// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// S-134: runtime-validation. `vite.config.ts:23-25` (S-117) emittar tomma
// strängar när env-vars saknas → utan denna check kallades
// `createClient('', '', …)` tyst och alla downstream-anrop fail:ade med
// opaque CORS/401 i devtools. Loggning sker bara i web-mode (desktop-
// builds disable:ar Supabase helt — VITE_DESKTOP=true). Testbar i jsdom
// via `console.error`-spy: se `src/test/supabaseClientEnvValidation.test.ts`.
const IS_DESKTOP = import.meta.env.VITE_DESKTOP === 'true';
if (!IS_DESKTOP && (!SUPABASE_URL || !SUPABASE_PUBLISHABLE_KEY)) {
   
  console.error(
    '[supabase-client] VITE_SUPABASE_URL eller VITE_SUPABASE_PUBLISHABLE_KEY ' +
    'saknas — alla Supabase-anrop kommer att fail:a med 401/CORS. ' +
    'Kopiera .env.example till .env och sätt egna projekt-credentials.',
  );
}

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
